import React, { useState, useEffect } from "react";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import { Col, Row, Label, Input, Form } from "reactstrap";
import { UserConsumer } from "../../../UserContext";
import FilterationBar from "./FilterationBar";
import { AlertPopups } from "../../../components/AlertPopups";
import "./SpResourceLeavesInfo.scss";
import { Redirect, useParams } from "react-router-dom";
import { ResourceLeavesInfo_API } from "./ResourceLeavesInfo_API";
import ButtonLoader from "../../../components/ButtonLoader";
import {
	ExcelBtnClassName,
	ExcelBtnTitle,
} from "../../ticketModule/variables/ListingVariables";

function AdminResourceLeavesInfo() {
	let token = null;
	const { id } = useParams();
	const [supervisorsEmpList, setSupervisorsEmpList] = useState(null);
	const [selectedSupEmpList, setSelectedSupEmpList] = useState(null);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [isActive, setIsActive] = useState(false);
	const [showBtnLoading, setShowBtnLoading] = useState(false);
	const [resLeavesInfoData, setResLeavesInfoData] = useState({
		empID: "",
		employeeName: "",
		employeeCode: "",
		employeeDepartment: "",
		sickLeave: "",
		totalSickLeave: "",
		compansationLeave: "",
		totalCompansationLeave: "",
		annualLeave: "",
		totalAnnualLeave: "",
		withoutPayLeave: "",
		totalWithoutPayLeave: "",
		maternityLeave: "",
		totalMaternityLeave: "",
		otherLeave: "",
	});

	const validate = Yup.object().shape({
		sickLeave: Yup.string().required("Required").nullable(),
		totalSickLeave: Yup.string().required("Required").nullable(),
		compansationLeave: Yup.string().required("Required").nullable(),
		totalCompansationLeave: Yup.string().required("Required").nullable(),
		annualLeave: Yup.string().required("Required").nullable(),
		totalAnnualLeave: Yup.string().required("Required").nullable(),
		withoutPayLeave: Yup.string().required("Required").nullable(),
		totalWithoutPayLeave: Yup.string().required("Required").nullable(),
		maternityLeave: Yup.string().required("Required").nullable(),
		totalMaternityLeave: Yup.string().required("Required").nullable(),
		otherLeave: Yup.string().required("Required").nullable(),
	});

	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };
		if (id) {
			//get resource info
			axios
				.get(
					`${ResourceLeavesInfo_API.GetResourceLeavesInfoById}/${id}`,
					{
						headers: header,
					}
				)
				.then(({ status, data }) => {
					if (status === 200) {
						setResLeavesInfoData(data);
					}
				});
		} else {
			// if admin is logged in :
			axios
				.get(`${ResourceLeavesInfo_API.GetAdminEmployeesList}`, {
					headers: header,
				})
				.then(({ status, data }) => {
					if (status === 200) {
						const supEmpList = data.map((obj) => {
							return { value: obj.employeeId, label: obj.name };
						});
						setSupervisorsEmpList(
							supEmpList.sort((a, b) =>
								a.label.localeCompare(b.label)
							)
						);
					}
				});
		}
		setApiHeaderToken(header);
	}, []);
	const updateTableData = (employeeId) => {
		axios
			.get(
				`${ResourceLeavesInfo_API.GetResourceLeavesInfoById}/${employeeId}`,
				{
					headers: apiHeaderToken,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					setResLeavesInfoData(data);
				}
			});
	};
	const handleSubmit = () => {
		const empId = resLeavesInfoData.employeeID;
		axios
			.put(
				`${ResourceLeavesInfo_API.PUTResourceLeaveInfo}/${empId}`,
				resLeavesInfoData,
				{
					headers: apiHeaderToken,
				}
			)
			.then(({ status, message }) => {
				if (status === 200) {
					AlertPopups.successAlert.fire({
						text: "Added",
					});
				} else if (status === 400) {
					AlertPopups.ErrorAlert.fire({
						text: message,
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
	};
	const updateDropDownList = (isActive) => {
		setSelectedSupEmpList(null);
		axios
			.get(
				`${
					ResourceLeavesInfo_API.GetActiveInActiveEmployee
				}=${!isActive}`,
				{
					headers: apiHeaderToken,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					const supEmpList = data.map((obj) => {
						return { value: obj.employeeId, label: obj.name };
					});
					setSupervisorsEmpList(
						supEmpList.sort((a, b) =>
							a.label.localeCompare(b.label)
						)
					);
				}
			});
	};

	const exportToExcel = () => {
		setShowBtnLoading(true);
		axios({
			url: `${
				ResourceLeavesInfo_API.ExportToExcel
			}?AllEmployees=${!isActive}`,
			method: "GET",
			responseType: "blob",
			headers: apiHeaderToken,
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "Leaves Info.xlsx");
				document.body.appendChild(link);
				link.click();
				setShowBtnLoading(false);
			})
			.catch(() => {
				setShowBtnLoading(false);
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") ? (
					<>
						<FilterationBar
							className="my-4"
							supervisorsEmpList={supervisorsEmpList}
							selectedSupEmpList={selectedSupEmpList}
							onSupEmpChange={(value) => {
								setSelectedSupEmpList(value);
								updateTableData(value.value);
							}}
							isActive={isActive}
							onActiveChange={() => {
								setIsActive(!isActive);
								updateDropDownList(!isActive);
							}}
						/>

						<Row>
							<Col className="d-flex justify-content-end">
								<ButtonLoader
									className={ExcelBtnClassName}
									onClick={exportToExcel}
									btnTitle={ExcelBtnTitle}
									showBtnLoading={showBtnLoading}
								/>
							</Col>
						</Row>
						{selectedSupEmpList && (
							<Formik
								enableReinitialize={true}
								initialValues={resLeavesInfoData}
								validationSchema={validate}
								validateOnChange={true}
								onSubmit={() => {
									handleSubmit();
								}}
							>
								{({ errors, handleSubmit }) => (
									<Form>
										<div className="mt-3 formInfoContainer">
											<div className="formInfoContainerHeader">
												<Label sm={12}>
													Personal Information
												</Label>
											</div>
											<Row className="py-2 px-4">
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>Employee Name</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<p className="formValueContainer">
														{
															resLeavesInfoData.employeeName
														}
													</p>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>Employee Code</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<p className="formValueContainer">
														{
															resLeavesInfoData.employeeCode
														}
													</p>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>Department</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<p className="formValueContainer">
														{
															resLeavesInfoData.employeeDepartment
														}
													</p>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>Others</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.otherLeave
														}
														onChange={(event) => {
															setResLeavesInfoData(
																{
																	...resLeavesInfoData,
																	["otherLeave"]:
																		event
																			.target
																			.value,
																}
															);
														}}
														className={`formValueInput ${
															errors.otherLeave
																? "h-auto invalid"
																: "h-auto"
														} `}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Remaining Sick
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.sickLeave
														}
														onChange={(event) => {
															setResLeavesInfoData(
																{
																	...resLeavesInfoData,
																	["sickLeave"]:
																		event
																			.target
																			.value,
																}
															);
														}}
														className={`formValueInput ${
															errors.sickLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>Total Sick</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.totalSickLeave
														}
														onChange={(event) => {
															setResLeavesInfoData(
																{
																	...resLeavesInfoData,
																	["totalSickLeave"]:
																		event
																			.target
																			.value,
																}
															);
														}}
														className={`formValueInput ${
															errors.totalSickLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Remaining Annual
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.annualLeave
														}
														onChange={(event) => {
															setResLeavesInfoData(
																{
																	...resLeavesInfoData,
																	["annualLeave"]:
																		event
																			.target
																			.value,
																}
															);
														}}
														className={`formValueInput  ${
															errors.annualLeave
																? "h-auto invalid"
																: "h-auto"
														} `}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>Total Annual</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.totalAnnualLeave
														}
														onChange={(event) => {
															setResLeavesInfoData(
																{
																	...resLeavesInfoData,
																	["totalAnnualLeave"]:
																		event
																			.target
																			.value,
																}
															);
														}}
														className={`formValueInput  ${
															errors.totalAnnualLeave
																? "h-auto invalid"
																: "h-auto"
														} `}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Remaining
															Compensation
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.compansationLeave
														}
														onChange={(event) => {
															setResLeavesInfoData(
																{
																	...resLeavesInfoData,
																	["compansationLeave"]:
																		event
																			.target
																			.value,
																}
															);
														}}
														className={`formValueInput ${
															errors.compansationLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Total Compensation
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.totalCompansationLeave
														}
														onChange={(event) => {
															setResLeavesInfoData(
																{
																	...resLeavesInfoData,
																	["totalCompansationLeave"]:
																		event
																			.target
																			.value,
																}
															);
														}}
														className={`formValueInput ${
															errors.totalCompansationLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Remaining Maternity
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.maternityLeave
														}
														onChange={(event) => {
															setResLeavesInfoData(
																{
																	...resLeavesInfoData,
																	["maternityLeave"]:
																		event
																			.target
																			.value,
																}
															);
														}}
														className={`formValueInput ${
															errors.maternityLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Total Maternity
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.totalMaternityLeave
														}
														onChange={(event) => {
															setResLeavesInfoData(
																{
																	...resLeavesInfoData,
																	["totalMaternityLeave"]:
																		event
																			.target
																			.value,
																}
															);
														}}
														className={`formValueInput ${
															errors.totalMaternityLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Remaining Without
															Pay
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.withoutPayLeave
														}
														onChange={(event) => {
															setResLeavesInfoData(
																{
																	...resLeavesInfoData,
																	["withoutPayLeave"]:
																		event
																			.target
																			.value,
																}
															);
														}}
														className={`formValueInput ${
															errors.withoutPayLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Total Without Pay
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.totalWithoutPayLeave
														}
														onChange={(event) => {
															setResLeavesInfoData(
																{
																	...resLeavesInfoData,
																	["totalWithoutPayLeave"]:
																		event
																			.target
																			.value,
																}
															);
														}}
														className={`formValueInput ${
															errors.totalWithoutPayLeave
																? "h-auto invalid"
																: "h-auto"
														}
                    `}
													/>
												</Col>
											</Row>
										</div>
										<Row className="extractDetail-form-btns">
											<Col className="p-0">
												<input
													type="submit"
													value="Submit"
													className="submit-btn"
													onClick={handleSubmit}
												/>
											</Col>
										</Row>
									</Form>
								)}
							</Formik>
						)}
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default AdminResourceLeavesInfo;
